const ResetCursor = () => {
  const allDots = document.querySelectorAll(
    ".cursor-dot, .cursor-dot1, .cursor-dot2, .cursor-dot3, .cursor-dot4, .cursor-dot5"
  );

  const blinkDot = document.querySelector(".cursor-blink");

  allDots.forEach((dot) => {
    dot.style.display = "block";
  });

  if (blinkDot) {
    blinkDot.style.display = "none";
  }
};

export default ResetCursor;